import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-user-disabled-popup',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './user-disabled-popup.component.html',
    styleUrl: './user-disabled-popup.component.scss',
})
export class UserDisabledPopupComponent {
    constructor(private dialogRef: MatDialogRef<UserDisabledPopupComponent>) {}

    closeDialog() {
        this.dialogRef.close();
    }

    onForgotPassword() {
        this.closeDialog();
    }
}
